export default __webpack_public_path__ + "static/media/smile.a8ca2640.svg";